/**
 * JWT Authentication Utility for Public Access
 * - สร้าง JWT Token อัตโนมัติสำหรับ Public Role
 * - ไม่ต้องมีระบบ Login
 */

// JWT Token ที่ได้จาก JWT Debugger (ใช้ Token เดียวกันสำหรับทุกคน)
const PUBLIC_JWT_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzbGlsLWRhdGFiYXNlLXB1YmxpYyIsInN1YiI6ImFub255bW91cy11c2VyIiwiaWF0IjoxNzEwMDAwMDAwLCJleHAiOjE4OTM0NTYwMDAsImh0dHBzOi8vaGFzdXJhLmlvL2p3dC9jbGFpbXMiOnsieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoicHVibGljIiwieC1oYXN1cmEtYWxsb3dlZC1yb2xlcyI6WyJwdWJsaWMiXX19.h-ar_Vt2V7vFpuc8g7_w6nouW6O5VSBNqapmIuzPY8Q";

/**
 * ดึง JWT Token สำหรับ Public Access
 * @returns {string} JWT Token
 */
export function getPublicToken() {
  // สามารถเก็บใน localStorage เพื่อไม่ให้สร้างใหม่ทุกครั้ง (Optional)
  let token = localStorage.getItem("public_jwt_token");

  if (!token) {
    token = PUBLIC_JWT_TOKEN;
    localStorage.setItem("public_jwt_token", token);
  }

  return token;
}

/**
 * ตรวจสอบว่า Token หมดอายุหรือไม่ (Optional)
 * @param {string} token - JWT Token
 * @returns {boolean}
 */
export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp * 1000; // แปลงเป็น milliseconds
    return Date.now() >= exp;
  } catch (error) {
    return true;
  }
}

/**
 * รีเฟรช Token (ถ้า Token หมดอายุ)
 */
export function refreshTokenIfNeeded() {
  const token = getPublicToken();

  if (isTokenExpired(token)) {
    // ถ้าหมดอายุ ให้สร้างใหม่หรือเรียก API เพื่อขอ Token ใหม่
    localStorage.removeItem("public_jwt_token");
    return getPublicToken();
  }

  return token;
}
